import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Resolve,
	RouterStateSnapshot,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { AppState } from 'src/app/reducers';
import { selectCohortsLoaded } from '../cohorts/redux/cohorts-selectors';
import { SideMenuActions } from '../side-menu/side-menu-action-types';
import { selectSideMenuState } from '../side-menu/side-menu.selectors';
// import { initializeMentorRequestPage } from './redux/mentor-request-actions';

@Injectable()
export class StudentAnalyticsResolver implements Resolve<any> {
	constructor(private store: Store<AppState>) {}

	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<any> {
		return this.store.pipe(
			select(selectCohortsLoaded),
			tap(cohortsLoaded => {
				this.store
					.pipe(select(selectSideMenuState))
					.pipe(
						tap(sideMenuState => {
							if (!sideMenuState.sideMenu.length) {
								this.store.dispatch(SideMenuActions.loadSideMenu());
							}
						}),
						filter(sideMenu => sideMenu.sideMenu.length > 0),
						first(),
					)
					.subscribe();
			}),
			first(),
		);
	}
}
